import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import Table2 from "../../../components/common/Table/Table2";
import Search from "../../../components/common/Search";
import SkeletonElement from "../../../components/Skeletons/SkeletonElement";
import EMPTY from "../../../assets/images/icons/empty.svg";
import {useToasts} from "react-toast-notifications";

import restService from "../../../services/restService";
import Pusher from "pusher-js";
import moment from "moment";

const defaultImg =
  "https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png";

const AgencyProfile = () => {
  const [loading, setLoading] = useState(false);
  const {addToast} = useToasts();
  const [agent, setAgent] = useState({});
  const [images, setImages] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState("");
  const [partner, setPartner] = useState("");
  const [partners, setPartners] = useState([]);
  const id = window.location.href.substring(
    window.location.href.lastIndexOf("/") + 1
  );
  const [lightBox, setLightBox] = useState({
    photoIndex: 0,
    isOpen: false,
  });

  const suspendAgent = () => {
    let data = {id, status: "suspended"};
    restService.AgentApi.updateAgent(data).then((response) => {
      setAgent({...agent, status: "suspended"});
      addToast("Successfully Suspended Agent", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
    });
  };

  const activateAgent = () => {
    let data = {id, status: "active"};
    restService.AgentApi.updateAgent(data).then((response) => {
      addToast("Successfully activated Agent", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      setAgent({...agent, status: "active"});
    });
  };

  const setTopUpCallback = (data) => {
    let user = {...agent};
    user.balance_available = data.message?.model.balance_available;
    user.actual_balance = data.message?.model.actual_balance;
    setAgent(user);
  };

  const setDebtCallback = (data) => {
    let user = {...agent};
    user.balance_owed = data.message?.model.balance_owed;

    setAgent({...user});
  };

  const changeRole = ({target}) => {
    let data = {id, agent_role: target.value};
    setRole(target.value);
    restService.AgentApi.updateAgent(data).then(({data}) => {
      setAgent(data?.data);
      addToast("Successfully Changed Agent Role", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
    });
  };

  const changePartner = ({target}) => {
    setPartner(target.value);
    if (target.value) {
      let data = {id, partners: [target.value]};
      restService.AgentApi.updateAgent(data).then((response) => {
        addToast("Successfully Changed Partner", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      });
    }
  };

  const removeAgent = (id) => {
    restService.AgentApi.removeAgent(id).then((response) => {
      addToast("Successfully Removed Agent", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
    });
  };

  useEffect(() => {
    restService.AgentApi.getAgent(id).then(({data}) => {
      setAgent(data?.data);
    });
    restService.TransactionsApi.getTransactionsByAgent(id).then(({data}) => {
      setTransactions(data?.data?.data);
    });
    restService.UtilsApi.getAgentRoles().then(({data}) => {
      setRoles(data?.data);
    });
  }, []);

  useEffect(() => {
    const pusher = new Pusher(
        import.meta.env.VITE_API_ENVIRONMENT === "dev"
            ? import.meta.env.VITE_PUSHER_KEY_DEVELOPMENT:
            import.meta.env.VITE_API_ENVIRONMENT === "staging" ?
                import.meta.env.VITE_PUSHER_KEY_STAGING
                : import.meta.env.VITE_PUSHER_KEY_PRODUCTION,
      {
        cluster: "eu",
        forceTLS: true,
      }
    );
    const channel = pusher.subscribe(
      `funding-agency-${agent?.agency?.id}-agent-${agent?.id}`
    );
    channel.bind("agent-debt-reduction", setDebtCallback);

    channel.bind("agent-evalue-topup", setTopUpCallback);

    restService.UtilsApi.getPartners().then(({data}) => {
      const partnerObject = data?.data;
      const formattedPartners = [];
      Object.keys(partnerObject)?.forEach((key) => {
        formattedPartners.push({
          name: partnerObject[key],
          id: Number(key),
        });
      });

      setPartners(formattedPartners);
      const defaultPartner = formattedPartners.filter(
        (p) => p.id === agent.partners?.[0]?.id
      )?.[0]?.id;
      setPartner(defaultPartner);
      setRole(agent?.agent_role?.name);
    });
  }, [agent]);

  return (
    <div className="flex flex-col w-full gap-6 mt-[5rem]">
      <div className="flex items-center gap-4">
        <Link to={`/`} className="cursor-pointer">
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.77778 0L0 4.33333V13H3.61111V7.94444H7.94444V13H11.5556V4.33333L5.77778 0Z"
              fill="#495465"
            />
          </svg>
        </Link>

        <span>
          {" "}
          <svg
            width="9"
            height="11"
            viewBox="0 0 9 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.8846 4.58215L0.555664 0.397949V2.60847L6.55566 5.50978L0.555664 8.43084V10.6019L8.8846 6.43742V4.58215Z"
              fill="#D1D5DC"
            />
          </svg>
        </span>

        <Link className="cursor-pointer md:text-sm text-xs" to={"/agencies"}>
          Agencies
        </Link>

        <span>
          {" "}
          <svg
            width="9"
            height="11"
            viewBox="0 0 9 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.8846 4.58215L0.555664 0.397949V2.60847L6.55566 5.50978L0.555664 8.43084V10.6019L8.8846 6.43742V4.58215Z"
              fill="#D1D5DC"
            />
          </svg>
        </span>

        <span className="px-4 py-2 rounded-xl md:text-sm text-xs bg-[#F7F8FD] border border-[#E3E8FF] ">
          {`${agent.firstname ? agent.firstname : ""} ${
            agent.othernames ? agent.othernames : ""
          }  ${agent.lastname ? agent.lastname : ""}`}
        </span>
      </div>

      <div className="md:grid w-full flex flex-col md:grid-cols-[28%,70.5%] gap-4">
        <div className="flex-[.8] w-full  flex flex-col gap-6 bg-white px-8 border border-theme-31 rounded-md py-7">
          <div className="flex items-center justify-center flex-col gap-1">
            <span>
              <img
                src={defaultImg}
                alt=""
                className="w-[87px] h-[87px] object-cover rounded-full"
              />
            </span>
            <p className="text-black text-base font-bold">{`${
              agent.firstname ? agent.firstname : ""
            } ${agent.othernames ? agent.othernames : ""}  ${
              agent.lastname ? agent.lastname : ""
            }`}</p>
            <p
              className={
                "text-white capitalize text-xs rounded-[100px]  px-4 py-1 " +
                (agent.status === "suspended" ? "bg-red-500" : "bg-[#006D49]")
              }
            >
              {agent.status}
            </p>
          </div>

          <ul className="flex flex-col gap-3">
            <li className="flex items-center justify-between border-t border-b border-[#ECECEC] py-3 gap-2">
              <span className="text-xs w-full text-[#727681]">Joined</span>

              <div className="flex flex-col items-end justify-end w-full">
                <p className="text-black whitespace-nowrap">
                  {" "}
                  {moment(new Date(agent.created_at)).format("MMMM DD, YYYY")}
                </p>
              </div>
            </li>
            <li className="flex items-center justify-between border-b border-[#ECECEC] pb-3 gap-2">
              <span className="text-xs w-full text-[#727681]">
                Actual Balance
              </span>

              <div className="flex flex-col items-end justify-end w-full">
                <p className="text-black">
                  {agent.agency?.country?.currency_symbol}{" "}
                  {agent.actual_balance}
                </p>
              </div>
            </li>
            <li className="flex items-center justify-between border-b border-[#ECECEC] pb-3 gap-2">
              <span className="text-xs w-full text-[#727681]">
                Account Balance
              </span>

              <div className="flex flex-col items-end justify-end w-full">
                <p className="text-black">
                  {" "}
                  {agent.agency?.country?.currency_symbol}{" "}
                  {agent.balance_available}
                </p>
              </div>
            </li>
            <li className="flex items-center justify-between border-b border-[#ECECEC] pb-3 gap-2">
              <span className="text-xs w-full text-[#727681]">
                Balance Owed
              </span>

              <div className="flex flex-col items-end justify-end w-full">
                <p className="text-black">
                  {" "}
                  {agent.agency?.country?.currency_symbol} {agent.balance_owed}
                </p>
              </div>
            </li>
            <li className="flex items-center justify-between border-b border-[#ECECEC] pb-3 gap-2">
              <span className="text-xs text-[#727681] flex-[.6]">Role</span>

              <div className="flex flex-col flex-[1.4] items-end justify-end w-full">
                <select
                  id="custom-form-select"
                  value={role}
                  onChange={changeRole}
                  name="agent_role"
                  className="form-select"
                >
                  {roles.map((role) => {
                    return <option value={role.name}>{role.name}</option>;
                  })}
                </select>
              </div>
            </li>
            <li className="flex items-center justify-between  pb-3 gap-2">
              <span className="text-xs text-[#727681] flex-[.6]">Partner</span>

              <div className="flex flex-col flex-[1.4] items-end justify-end w-full">
                <select
                  id="custom-form-select"
                  value={partner}
                  onChange={changePartner}
                  name="partner"
                  className="form-select"
                >
                  <option value={undefined}>Select a partner</option>
                  {partners.map((partner) => {
                    return <option value={partner.id}>{partner.name}</option>;
                  })}
                </select>
              </div>
            </li>
          </ul>

          <div className="flex justify-center w-full mt-2">
            {agent.status?.toLowerCase() === "active" ? (
              <button
                onClick={suspendAgent}
                className="rounded-md bg-[#EA3323] hover:bg-[#EA3323f1] transition py-2 px-4 text-white"
              >
                Suspend
              </button>
            ) : (
              <button
                onClick={activateAgent}
                className="rounded-md bg-[#006D49] hover:bg-[#006d49f1] transition py-2 px-4 text-white"
              >
                Activate
              </button>
            )}
          </div>
        </div>

        <div className="flex flex-[1.2] flex-col gap-4">
          <div className=" w-full px-8 border border-theme-31 rounded-md py-7 bg-white flex md:flex-row flex-col gap-8">
            <div className="flex items-center gap-2 flex-col">
              <span className="rounded-full bg-[#F7F8FD] flex items-center justify-center h-[45px] w-[45px]">
                <svg
                  width="26"
                  height="19"
                  viewBox="0 0 26 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.9231 9.3405C15.8605 9.3405 14.833 8.86734 14.0289 8.00865C13.2469 7.17108 12.7694 6.05416 12.6851 4.86456C12.5952 3.59559 12.9833 2.42867 13.7777 1.57822C14.572 0.72777 15.6827 0.269043 16.9231 0.269043C18.1547 0.269043 19.2684 0.736017 20.0602 1.5844C20.8597 2.44104 21.2489 3.6059 21.159 4.86405C21.0727 6.05519 20.5956 7.1716 19.8152 8.00813C19.0131 8.86734 17.9862 9.3405 16.9231 9.3405ZM23.7364 18.412H10.1103C9.89123 18.4131 9.6748 18.3642 9.47768 18.2688C9.28057 18.1735 9.10801 18.0343 8.97329 17.862C8.83039 17.6752 8.73171 17.4586 8.68463 17.2284C8.63755 16.9982 8.6433 16.7604 8.70144 16.5327C9.13661 14.7901 10.2147 13.3448 11.8189 12.3537C13.2428 11.4744 15.0553 10.9899 16.9231 10.9899C18.8276 10.9899 20.5925 11.4537 22.0247 12.3325C23.6325 13.3185 24.7121 14.772 25.1452 16.5358C25.2027 16.7637 25.2078 17.0015 25.1602 17.2316C25.1126 17.4616 25.0135 17.678 24.8703 17.8646C24.7357 18.0361 24.5635 18.1746 24.367 18.2694C24.1705 18.3643 23.9547 18.4131 23.7364 18.412ZM7.1551 9.54667C5.3364 9.54667 3.73735 7.86021 3.58902 5.78769C3.51563 4.72591 3.84743 3.74403 4.5193 3.02398C5.18394 2.31115 6.12146 1.9184 7.1551 1.9184C8.18875 1.9184 9.11903 2.31321 9.78729 3.03017C10.4643 3.75589 10.7951 4.73571 10.7176 5.78872C10.5692 7.86072 8.97071 9.54667 7.1551 9.54667ZM10.5486 11.1677C9.63948 10.7244 8.45957 10.5028 7.15562 10.5028C5.63306 10.5028 4.15442 10.8986 2.99157 11.6171C1.67315 12.433 0.786279 13.6211 0.42812 15.0555C0.375706 15.2618 0.370749 15.4773 0.413619 15.6858C0.456488 15.8943 0.546075 16.0905 0.675679 16.2596C0.798656 16.417 0.956203 16.5442 1.1362 16.6314C1.3162 16.7186 1.51386 16.7635 1.71398 16.7626H7.45073C7.54755 16.7626 7.6413 16.7287 7.71563 16.6668C7.78997 16.6049 7.84016 16.519 7.85747 16.424C7.86315 16.3915 7.87039 16.359 7.87866 16.3271C8.31692 14.5715 9.34385 13.0881 10.8612 12.0068C10.9171 11.9667 10.9619 11.9133 10.9918 11.8515C11.0218 11.7897 11.0357 11.7215 11.0325 11.6529C11.0292 11.5844 11.0089 11.5177 10.9733 11.459C10.9377 11.4003 10.888 11.3514 10.8287 11.3166C10.7475 11.2692 10.6545 11.2192 10.5486 11.1677Z"
                    fill="#0042C6"
                  />
                </svg>
              </span>
              <span className="text-black font-medium">About</span>
            </div>

            <ul className="w-full grid md:grid-cols-3 grid-cols-2 gap-6 bg-[#F9FAFB] rounded-md px-8 py-6">
              <li className="flex flex-col gap-1">
                <p className="text-xs text-[#687083]">First Name</p>
                <p className=" text-[#282424]">{agent.firstname}</p>
              </li>
              <li className="flex flex-col gap-1">
                <p className="text-xs text-[#687083]">Other Names</p>
                <p className=" text-[#282424]">
                  {agent.othernames} {agent.lastname}
                </p>
              </li>
              <li className="flex flex-col gap-1">
                <p className="text-xs text-[#687083]">Contact Info</p>
                <p className=" text-[#282424]">{agent.msisdn}</p>
              </li>
              <li className="flex flex-col gap-1">
                <p className="text-xs text-[#687083]">Email Address</p>
                <a href="mailto:jane@example.com" className=" text-[#282424]">
                  {agent.email}
                </a>
              </li>
              <li className="flex flex-col gap-1">
                <p className="text-xs text-[#687083]">Address</p>
                <p className=" text-[#282424] md:whitespace-nowrap md:w-[25vw] overflow-hidden overflow-ellipsis">
                  {agent.address}
                </p>
              </li>
            </ul>
          </div>
          <div className=" bg-white px-8 border h-full flex flex-col gap-3 border-theme-31 rounded-md py-7">
            <div className="flex items-center justify-between ">
              <h2 className="text-base font-medium text-black">
                Identifications
              </h2>

              <div className="flex items-center gap-4">
                <Search
                  placeholder={"Search"}
                  // onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="flex w-full flex-col">
              <Table2
                divide="no"
                // headData={head}
                tHead={
                  <>
                    <th className="">Type</th>
                    <th className="">Category</th>
                    <th className="">Date Issued</th>
                    <th className="">Expiry Date</th>
                    <th className="">Status</th>
                    <th className="text-center">Action</th>
                  </>
                }
                // renderHead={(item, index) => renderHeadData(item, index)}
              >
                {Array(0)
                  .fill()
                  .map((item, index) => (
                    <tr key={index} className="">
                      <td>
                        <div className="flex items-center gap-2">
                          <span
                            title="ee"
                            className="text-black font-medium overflow-hidden overflow-ellipsis whitespace-nowrap w-[140px]"
                          >
                            John Maddy Newman{" "}
                          </span>
                        </div>
                      </td>
                      <td>
                        <p
                          title="sf"
                          className="overflow-hidden overflow-ellipsis whitespace-nowrap w-[140px]"
                        >
                          $200.00
                        </p>
                      </td>
                      <td>
                        <p className="">$200.00</p>
                      </td>
                      <td>
                        <p className="font-medium text-black">$200.00</p>
                      </td>
                      <td>
                        <p className="">12/12/2022</p>
                      </td>
                      <td>
                        <p className="rounded-[100px] status-pending text-center px-2 py-1.5">
                          Pending
                        </p>
                      </td>
                    </tr>
                  ))}
              </Table2>
            </div>
            <div className="flex items-center justify-center h-full w-full">
              <img src={EMPTY} alt="" />
            </div>

            <div className="flex items-center justify-center w-full">
              <p className="text-xs text-[#999999]">Showing 0 out of 0 items</p>
            </div>
          </div>
        </div>
      </div>

      <div className=" w-full px-8 border border-theme-31 rounded-md py-7 bg-white flex flex-col gap-4 ">
        <h2 className="text-base font-medium text-black">Transactions</h2>

        {!loading ? (
          <div className="flex w-full flex-col">
            <Table2
              divide="no"
              // headData={head}
              tHead={
                <>
                  <th className="">Sender</th>
                  <th className="">Receipient</th>
                  <th className="">Amount Sent</th>
                  <th className="">Amount Recieved</th>
                  <th className="">Charge</th>
                  <th className="">Date</th>
                  <th className="text-center">Status</th>
                  <th className=""></th>
                </>
              }
              // renderHead={(item, index) => renderHeadData(item, index)}
            >
              {transactions.map((item, index) => (
                <tr key={index} className="">
                  <td>
                    <div className="flex items-center gap-2">
                      <span
                        title="ee"
                        className="text-black font-medium overflow-hidden overflow-ellipsis whitespace-nowrap w-[140px]"
                      >
                        {`${item?.sender?.firstname} ${item?.sender?.lastname}`}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className="flex items-center gap-2">
                      <span
                        title="ee"
                        className="text-black font-medium overflow-hidden overflow-ellipsis whitespace-nowrap w-[140px]"
                      >
                        {`${item.receiver.firstname} ${item.receiver.lastname}`}
                      </span>
                    </div>
                  </td>
                  <td>
                    <p
                      title="sf"
                      className="overflow-hidden overflow-ellipsis whitespace-nowrap w-[140px]"
                    >
                      {item.source_currency} {item.send_amount}
                    </p>
                  </td>
                  <td>
                    <p className="whitespace-nowrap">
                      {" "}
                      {item.destination_currency} {item.receive_amount}
                    </p>
                  </td>
                  <td>
                    <p className="font-medium whitespace-nowrap text-black">
                      {" "}
                      {item.source_currency} {item.charge}
                    </p>
                  </td>
                  <td>
                    <p className="whitespace-nowrap">
                      {moment(new Date(item.created_at)).format(
                        "MMMM DD, YYYY"
                      )}
                    </p>
                  </td>
                  <td>
                    <p
                      className={`rounded-[100px] status-${item?.transaction_status?.status?.toLowerCase()} text-center px-4 py-1.5`}
                    >
                      {item?.transaction_status?.status}
                    </p>
                  </td>
                  <td>
                    <Link to={`/transaction/${item.id}`}>
                      <svg
                        className="cursor-pointer"
                        width="16"
                        height="10"
                        viewBox="0 0 16 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.8418 0C4.43271 0 1.52134 2.07333 0.341797 5C1.52134 7.92667 4.43271 10 7.8418 10C11.2509 10 14.1623 7.92667 15.3418 5C14.1623 2.07333 11.2509 0 7.8418 0ZM7.8418 8.33333C5.95998 8.33333 4.43271 6.84 4.43271 5C4.43271 3.16 5.95998 1.66667 7.8418 1.66667C9.72361 1.66667 11.2509 3.16 11.2509 5C11.2509 6.84 9.72361 8.33333 7.8418 8.33333ZM7.8418 3C6.70998 3 5.79634 3.89333 5.79634 5C5.79634 6.10667 6.70998 7 7.8418 7C8.97361 7 9.88725 6.10667 9.88725 5C9.88725 3.89333 8.97361 3 7.8418 3Z"
                          fill="#ACACAC"
                        />
                      </svg>
                    </Link>
                  </td>
                </tr>
              ))}
            </Table2>
          </div>
        ) : (
          <div className="flex w-full flex-col">
            <Table2
              // headData={head}
              tHead={
                <>
                  <th className="">Sender</th>
                  <th className="">Receipient</th>
                  <th className="">Amount Sent</th>
                  <th className="">Amount Recieved</th>
                  <th className="">Charge</th>
                  <th className="">Date</th>
                  <th className="text-center">Status</th>
                  <th className=""></th>
                </>
              }
              // renderHead={(item, index) => renderHeadData(item, index)}
            >
              {Array(5)
                .fill()
                .map((item, index) => (
                  <tr key={index}>
                    {Array(7)
                      .fill()
                      .map((x, i) => (
                        <td key={i}>
                          <SkeletonElement type={"title"} />
                        </td>
                      ))}
                  </tr>
                ))}
            </Table2>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgencyProfile;
